import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FormCad } from '../components';
import Swal from 'sweetalert2';
import initialData from './initialData';
import schema from './schema'
import { storeTipoLicenca, loadTipoLicencas, changeStatus } from '~/store/modules/tipo_licenca/action';

const Create = () => {
  let history = useHistory();
  const [tipoLicenca, setTipoLicenca] = useState(initialData);
  const [saved, setSaved] = useState(false);
  const { atividade_id } = useParams();
  const [errorsValidate, setErrorsValidate] = useState([]);
  const dispatch = useDispatch();
  const { status_response, errors } = useSelector(({ TipoLicencaReducer }) => TipoLicencaReducer);

  useEffect(() => {
    if (errors.status && errors.status === 422) {
      let server_errors = {};
      const response_errors = errors.data.errors;
      for (let name of Object.keys(response_errors)) {
        Object.assign(server_errors, { [name]: response_errors[name][0] });
      }
      setErrorsValidate(server_errors);
    }
    if(errors.save) {
      setSaved(errors.save);
    }
  }, [errors]);


  useEffect(() => {
    if (saved && status_response === 201) {
      Swal.fire('Sucesso', 'Registro salvo com sucesso!', 'success').then(
        () => {
          history.goBack();
          dispatch(loadTipoLicencas({
            where:`atividade_id:${atividade_id}`
          }));
          dispatch(changeStatus(null));
        }
      );
    }
  }, [status_response, history, dispatch, saved, atividade_id]);


  const handleClose = () => {
    history.goBack();
  };

  const handleSubmit = async event => {
    event.preventDefault();
    if (!schema.isValidSync(tipoLicenca)) {
      let yup_errors = {};
      schema.validate(tipoLicenca, { abortEarly: false }).catch(err => {
        for (let error of err.inner) {
          const { path, message } = error;
          Object.assign(yup_errors, { [path]: message });
        }
        setErrorsValidate(yup_errors);
      });
    } else {
      const tipo = tipoLicenca;
      tipo.atividade_id = parseInt(atividade_id);

      await dispatch(storeTipoLicenca(tipo));
    }
  };

  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="modal-xl"
      onHide={handleClose}
      show
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Tipo Licenca
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Novo</h2>
          </div>
          <div className="card-body">
            <FormCad
              tipo_licenca={tipoLicenca}
              errors={errorsValidate}
              handleSubmit={handleSubmit}
              schema={schema}
              setTipoLicenca={setTipoLicenca}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-default" onClick={handleClose}>
          <i className="fa fa-window-close" /> Cancelar
        </button>
        <button
          className="btn btn-success"
          form="form_tipo_licenca"
          type="submint"
        >
          {' '}
          <i className="fa fa-save" /> Salvar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default Create;
